import React, { useState, useEffect } from 'react'
import './SideBarComponent.css'
import { GrFormClose, GrFormSubtract } from 'react-icons/gr'
import { AiOutlinePlus } from 'react-icons/ai'
import SideBarSubMenu from '../SideBarSubMenu/SideBarSubMenu'
import { Link } from 'react-router-dom'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import userDefault from '../../Assets/images/userDefault.jpg'
import { isLoggedIn } from '../../Hooks/isLoggedIn'
export default function SideBarComponent({ showSideBar, ShowSideBarCloseHandler }) {
    const [user, setUser] = useState({
        id: '',
        username: '',
        profileImage: '',
    })
    const [selectedMenuIndex, setSelectedMenuIndex] = useState(null);
    const SubMenuActiveHandler = (index) => setSelectedMenuIndex(index)
    const SubMenuCloseHandler = () => setSelectedMenuIndex(null)
    const [courseMenuList, setCourseMenuList] = useState([])
    const [productMenuList, setProductMenuList] = useState([])
    useEffect(() => {
        axiosConfig.get('/api/Categories?categoryType=0').then((res) => {
            setCourseMenuList(res.data)
        })
        axiosConfig.get('/api/Categories?categoryType=1').then((res) => {
            setProductMenuList(res.data)
        })
        if (isLoggedIn()) {
            axiosConfig.get("api/user").then((res) => {
                setUser(res.data)
            })
        }
    }, [])
    let menuList = [
        {
            id: 0,
            menuName: 'صفحه اصلی',
            href: '/',
            subMenus: []
        },
        {
            id: 1,
            menuName: 'محصولات',
            href: '/products',
            subMenus: []
        },
        {
            id: 2,
            menuName: 'دوره ها',
            href: '/courses',
            subMenus: []
        },
        {
            id: 3,
            menuName: 'مقالات',
            href: '/articles',
            subMenus: []
        },
        {
            id: 4,
            menuName: 'مشاوره',
            href: '/counseling',
            subMenus: []
        },
        {
            id: 5,
            menuName: 'درباره ما',
            href: '/aboutus',
            subMenus: []
        }
        ,
        {
            id: 5,
            menuName: 'ارتباط با ما',
            href: '/counseling',
            subMenus: []
        }
    ]
    menuList[1].subMenus.push(productMenuList)
    menuList[2].subMenus.push(courseMenuList)
    return (
        <div className={`navbar-responsive-sidebar ${showSideBar ? 'active' : ''}`}>
            <div className='navbar-responsive-profile'>
                <div className='user-profile'>
                    {
                        user.profileImage != null ? (
                            <img src={axiosConfig.defaults.baseURL + "Images/UserImage/" + user.id + "/" + user.profileImage} alt={`پرفایل ${user.username}`} />
                        ) : (
                            <img src={userDefault} alt={`پرفایل ${user.username}`} />
                        )
                    }
                    <div className='user-profile-info'>
                        <h1>{isLoggedIn() ? (user.username) : (<Link to='/login'>ورورد به حساب</Link>)}</h1>
                        <h3>
                            {isLoggedIn() ? (
                                <Link to='/userpanel'>
                                    حساب کاربری
                                </Link>
                            ) : (null)}

                        </h3>
                    </div>
                </div>
                <div className='close-btn' onClick={ShowSideBarCloseHandler}>
                    <GrFormClose />
                </div>
            </div>
            <ul className='navbar-responsive-list'>
                {
                    menuList?.map((menu, index) => (
                        <li key={index}>
                            <div className='menu-title'>
                                <Link to={menu.href}>
                                    {menu.menuName}
                                </Link>

                                {
                                    menu.subMenus.length ? (
                                        <>
                                            {
                                                selectedMenuIndex === index ?
                                                    (<GrFormSubtract onClick={SubMenuCloseHandler} />) : (<AiOutlinePlus onClick={() => SubMenuActiveHandler(index)} />)
                                            }


                                        </>

                                    ) : null
                                }

                            </div>
                            <SideBarSubMenu Menu={menu} selectedMenuIndex={selectedMenuIndex} index={index} />
                        </li>
                    ))
                }
            </ul>
            <div className='permissions-image mt-10 text-center'>
                <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=450119&Code=zAgTd61FlvlcLcV8aAOJs8SYZInJvZE0'>
                    <img referrerpolicy='origin' width={100} height={100} src='https://trustseal.enamad.ir/logo.aspx?id=450119&Code=zAgTd61FlvlcLcV8aAOJs8SYZInJvZE0' alt='سه نیک تایید شده اینماد' style={{ cursor: 'pointer' }} Code='zAgTd61FlvlcLcV8aAOJs8SYZInJvZE0' />
                </a>
            </div>
        </div>
    )
}
